import {rates} from "./src/index";

export default rates;
